import React, { useState, useEffect } from "react";
import Breadcrumbs from "../layout/breadcrumb";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import DocumentRepositoryForm from "./document-repository-form";
import DocumentRepositoryList from "./document-repository-list";
import DprHeader from "../layout/dprHeader";
import { useLocation } from "react-router-dom";

function DocumentRepository() {
  const [activeTab, setActiveTab] = useState(0); // Track active tab index
  const [rowData, setRowData] = useState(null); // State to store the selected row data
  const location = useLocation();
  const pro = location.state || {}; // Retrieve project data if available

  // Set activeTab to 1 if rowData contains data
  useEffect(() => {
    if (rowData) {
      setActiveTab(1);
    }
  }, [rowData]);

  // Reset rowData when switching to the "Document Repository Form" tab
  const handleTabChange = (index) => {
    setActiveTab(index);
    if (index === 1) {
      setRowData(null); // Reset rowData when switching to the form tab
    }
  };

  return (
    <> 
      {activeTab === 0 ? (
        <Breadcrumbs title="Document Repository" menu="Document Repository List" />
      ) : (
        <Breadcrumbs title="Document Repository" menu="Document Repository Form" />
      )}
      <DprHeader project={pro} />
      <div className="row mt-3">
        <Tabs selectedIndex={activeTab} onSelect={handleTabChange}>
          <div className="card p-2">
            <TabList>
              <Tab>Document Repository List</Tab>
              <Tab>Document Repository Form</Tab>
            </TabList>
            <hr />
            <TabPanel>
              <DocumentRepositoryList setRowData={setRowData} /> 
            </TabPanel>
            <TabPanel>
              <DocumentRepositoryForm rowData={rowData} />
            </TabPanel>
          </div>
        </Tabs>
      </div>
    </>
  );
}

export default DocumentRepository;
